/**
 * @fileoverview Barrel exports for the synopsis-extraction-pipeline-v3 composite.
 *
 * This composite orchestrates synopsis extraction with automatic
 * size-based routing between single-pass and chunked map-reduce.
 *
 * Composed of:
 * - plot-synopsis-extractor-v3 (single-pass extraction)
 * - plot-synopsis-extractor-chunked-v3 (per-chunk extraction, map phase)
 * - plot-synopsis-merge-v3 (merge chunk synopses, reduce phase)
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  InputSchema,
  OutputSchema,
  type Input,
  type Output,
} from './schema';

// Flow
export { flow } from './flow';

